export enum WorkCategory {
    LOGISTICS = 1,
    BUILDING = 2,
    TRANSPORT = 3,
    HOME_MASTER = 4,
}

export enum LogisticsSubcategories {
    UNLOADING_TRUCK = 1,
    LOADING_TRUCK = 2,
    MOVING_GOODS = 3,
    PACKING_SORTING = 4,
}

export enum BuildingSubcategories {
    UNLOADING_MATERIALS = 1,
    LIFTING_MATERIALS = 2,
    SITE_CLEANING = 3,
    DISMANTLING_STRUCTURES = 4,
    DIGGING = 5,
    OTHER = 6,
}

export enum TransportSubcategories {
    TRANSPORTATION_OF_MATERIALS = 1,
    TRANSPORTATION_OF_FURNITURE = 2,
    MOVING_FROM_HOUSE = 3,
    WASTE_REMOVAL = 4,
}

export enum HomeMasterSubcategories {
    FURNITURE_ASSEMBLY = 1,
    MINOR_REPAIRS = 2,
    REPAIR_OF_APPLIANCES = 3,
}

export const WorkCategoryWithSubcategories = {
    [WorkCategory.LOGISTICS]: LogisticsSubcategories,
    [WorkCategory.BUILDING]: BuildingSubcategories,
    [WorkCategory.TRANSPORT]: TransportSubcategories,
    [WorkCategory.HOME_MASTER]: HomeMasterSubcategories,
};
